import React from 'react';
import { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { useAddNewUserMutation, useGetUsersQuery } from '../../features/users/usersApiSlice';
import { useGetdesignationsQuery } from '../../features/designations/designationApiSlice';
import { useGetofficetypeQuery } from '../../features/officetype/officetypeApiSlice';
import { useGetStoreOfficesQuery } from '../../features/storeoffices/storeofficesApiSlice';
import { useGetrolesQuery } from '../../features/roles/rolesApiSlice';
import { useGetdesignationsuffixQuery } from '../../features/designationsuffix/designationSuffixApiSlice';
import { useGetofficesQuery } from '../../features/offices/officesApiSlice';
import { useUpdateofficeMutation } from '../../features/offices/officesApiSlice';
import Select from '@mui/material/Select';
import {OutlinedInput, MenuItem} from '@mui/material';
import { useIsMount } from '../../features/hooks/useIsMount';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import {HeadingWrap, Span, CommonButton } from '../../Styles/CommonStyles'
import Typography from '@mui/material/Typography';
import InputAdornment from '@mui/material/InputAdornment';
import AccountCircle from '@mui/icons-material/AccountCircle';




const USER_REGEX = /^[A-z][A-z0-9-_]{1,23}$/;
const EMAIL_REGEX = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{8,24}$/;
const MOBILE_REGEX = /^[0]?[789]\d{9}$/;
const EMPID_REGEX= /^[0-9]+$/;
const LANDLINE_REGEX= /^[0]\d{10}$/;
const OFFICEADD_REGEX=/.$/;

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const Adduser =styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 20px;
`
const Adduserformcont = styled.div`
  display: flex;
  flex-wrap:wrap;
  margin:10px;
`
const SubmitButton = styled(CommonButton)`
height:"40px";
margin-top:"0px";
margin-bottom:"0px";
`

const LabelInputWrapper = styled.div`
    margin-bottom:25px;
    flex:1 0 30%;
    display: ${(props) => props.disp};
`
const MainRolesWrapper = styled.div`
  display: flex;
`

const Label = styled.label`
    width: 50px;
`
const HeadingField = styled.div`
  font-weight: bold;
  margin-bottom:20px;
`
const SubHeadingField = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-left:10px;
    margin-top: 10px;
    margin-bottom: 5px;
    font-weight: bold;

    font-family: "Roboto","Helvetica","Arial",sans-serif;
    font-size: 20px;
    font-weight: 700;
    color: #5C5891;  
`

const flatten = (source, list) => {
    if (list === undefined) {
      list = []
    }
    for (const objs of (source || [])) {
      let { sub, ...item } = objs
      list.push(item)
      flatten(sub, list)
    }
    return list
  }

const childNames= (source, supoff, newarr) =>{ 
    if (newarr === undefined) {
        newarr = []
      }    
    for (const objs of (source || [])) {   
       if (objs.name === supoff) {
        if(objs.sub){
          for (const objs2 of objs.sub){
            let tempObj={};
            tempObj={"name":objs2.name, "type":objs2.type}
            newarr.push(tempObj);
          }
          break;
        }
        } else {
          childNames(objs.sub, supoff, newarr);
        }
      }
      return newarr;
    }
const fetchLabel = (index, value, officedata) => {
  let fetchLableArray = [];  
  if(value[`level${index}`].length){
    fetchLableArray = officedata? Object.values(officedata)?.find(x=> x.name === value[`level${index}`])?.type:[]
  } else {
    let tempFetchLableArray = officedata? Object.values(officedata)?.filter((i,k)=>i.superioroffice === value[`level${index-1}`])?.map((item,index) => item.type):[];
    console.log(tempFetchLableArray)
    //Removing duplicate entries.
    fetchLableArray = tempFetchLableArray.filter((item, index) => tempFetchLableArray.indexOf(item) === index)?.map((item,index) => index === 0? item:`/${item}`)
  }
  return fetchLableArray
}

const AddUsers = () =>{
    const [addNewUser, {
        isLoading,
        isSuccess,
        isError,
        error
    }] = useAddNewUserMutation();
    
    const [updateOff] = useUpdateofficeMutation();

    const userRef = useRef();
    const count = useRef(0);
    const isMount = useIsMount();
    const errRef = useRef();
    const initialUserState = {
      name:{firstName:"", middleName:"", lastName:""},
      email:"",
      password: "",
      mobileNo:"",
      officeLandLine:"",
      employeeID: "",
      officeAddress:"",
      office: {mainCharge:"", additionalCharge:[]},
      designation:{},
      designationSuffix:{},
      numSuffix:{},
      roles:{main:["user"]},
      assets:{},
      indi_assets:[],
      bo_assets:{},
      store_assets:{},
      active:true
  }

  
  const initialValueState = {
    firstname:"",
    middlename:"",
    lastname:"",
    email:"",
    password:"",
    confirmpassword:"",
    designation:"",
    designationsuffix:"",
    mobilenumber:"",
    landlinenumber:"",
    employeeid:"",
    officeaddress:"",
    level0:"",
    level1:"",
    level2:"",
    level3:"",
    level4:"",
    level5:"",
    store:"",
    roles:[]        
}
    const [subdispl, setSubdispl] = useState("none");
    const [presentOffType, setPresentOffType] = useState();
    const [officeType, setOfficeType] = useState([]);
    const [officeUnitHead, setOfficeUnitHead] = useState();
    const [reportingOfficer, setReportingOfficer] = useState();
    const [storeOffices, setStoreOffices] = useState([]);
    const [storeRole, setStoreRole] = useState([]);
    const [desigSuffix, setDesigSuffix] = useState([]);
    const [offices, setOffices] = useState([]);
    const [renderFields, setRenderFields] = useState([]);
    const [userData, setUserData] = useState([]);
    const [users, setUsers] = useState(initialUserState);
    const [value, setValue] = useState(initialValueState)
    const [desig, setDesig] = useState([])
    const [displ, setDispl] = useState({
        level1:"block",
        level2:"none",
        level3:"none",
        level4:"none",
        level5:"none",
    })
    const otherRoles = [
      'assetManager',
      'assetApprover'
    ]

    const [validFirstName, setValidFirstName] = useState(false);
    const [firstNameFocus, setFirstNameFocus] = useState(false);

    const [validMiddleName, setValidMiddleName] = useState(false);
    const [middleNameFocus, setMiddleNameFocus] = useState(false);

    const [validLastName, setValidLastName] = useState(false);
    const [lastNameFocus, setLastNameFocus] = useState(false);

    const [validEmail, setValidEmail] = useState(false);
    const [emailFocus, setEmailFocus] = useState(false);

    const [validPwd, setValidPwd] = useState(false);
    const [pwdFocus, setPwdFocus] = useState(false);

    const [validMatch, setValidMatch] = useState(false);
    const [matchFocus, setMatchFocus] = useState(false);

    const [validMobile, setValidMobile] = useState(false);
    const [mobileFocus, setMobileFocus] = useState(false);

    const [validEmpId, setValidEmpId] = useState(false);
    const [empIDFocus, setEmpIdFocus] = useState(false);

    const [validLandline, setValidLandline] = useState(false);
    const [landlineFocus, setLandlineFocus] = useState(false);

    const [validOfficeAdd, setValidOfficeAdd] = useState(false);
    const [officeAddFocus, setOfficeAddFocus] = useState(false);

    const [errMsg, setErrMsg] = useState('');
    const [success, setSuccess] = useState(false);


    useEffect(() => {
      count.current = count.current + 1;
    });

    useEffect(() => {
        userRef.current.focus();
    }, [])

    useEffect(() => {
        setValidFirstName(USER_REGEX.test(users.name.firstName));
        setValidMiddleName(USER_REGEX.test(users.name.middleName));
        setValidLastName(USER_REGEX.test(users.name.lastName));
    }, [users.name.firstName, users.name.middleName, users.name.lastName ])

    useEffect(() => {
        setValidEmail(EMAIL_REGEX.test(users.email));        
    }, [users.email])

    useEffect(() => {
        setValidPwd(PWD_REGEX.test(users.password));
        setValidMatch(users.password === value.confirmpassword);
    }, [users.password, value.confirmpassword])

    useEffect(() => {
        setValidMobile(MOBILE_REGEX.test(users.mobileNo));        
    }, [users.mobileNo])

    useEffect(() => {
        setValidEmpId(EMPID_REGEX.test(users.employeeID));        
    }, [users.employeeID])

    useEffect(() => {
        setValidLandline(LANDLINE_REGEX.test(users.officeLandLine));        
    }, [users.officeLandLine])

    useEffect(() => {
        setValidOfficeAdd(OFFICEADD_REGEX.test(users.officeAddress));        
    }, [users.officeAddress])

    // console.log(count)


    //Create a variable to store all the possible office types against a office level
    let officeTypeLabels = {}
    let i=1
    for(let val of officeType ){
      if(!Object.keys(officeTypeLabels).includes(val.level)){
        officeTypeLabels[val.level] = []
      }
      officeTypeLabels[val.level].push(val.type)
    }
    
    const onChangeuserform = (event, newValue, name) => {

      let tempUser = structuredClone(users);
      let tempValue ={...value}
      if(["firstName", "middleName", "lastName"].includes(event.target.name)){
        tempUser.name[event.target.name] = event.target.value;
      }
      if(["email","password","mobileNo","officeLandLine", "employeeID","officeAddress"].includes(event.target.name)){
        if (event.target.name === "mobileNo" && event.target.value.length > 10) {
          return alert("Mobile Number should be 10 digits")
        }
        tempUser = {...tempUser, [event.target.name]:event.target.value}
      }
      if(event.target.name === "confirmpassword"){
        tempValue = {...tempValue, [event.target.name]:event.target.value }
      }

      if(name?.includes("level") && newValue !== null){
        tempUser.office.mainCharge = newValue;
        setPresentOffType(offices.find(x => x.name === newValue).type)
        tempValue = {...tempValue, [name]:newValue}
        //Change type of office in label based on the office chosen.
        let tempRender = [];
        for(let i=0; i<6; i++){
          if(tempValue[`level${i}`].length){
            tempRender.push(tempValue[`level${i}`])
          }else{
            break;
          }
        }
        setRenderFields(tempRender);
      }

      if(name?.includes("level") && newValue === null){
          const levelIndex = name.charAt(name.length-1);
          tempUser.office.mainCharge = value[`level${levelIndex-1}`];
          setPresentOffType(offices.find(x => x.name === value[`level${levelIndex-1}`]).type)
          for(let i=levelIndex; i<7; i++){
              tempValue[`level${i}`] = "";
          }
          //Change type of office in label based on the office chosen.
          let tempRender = [];
          for(let i=0; i<6; i++){
            if(tempValue[`level${i}`].length){
              tempRender.push(tempValue[`level${i}`])
            }else{
              break;
            }
          }
          setRenderFields(tempRender);
      }

      if(name === "designation"){
        tempUser.designation[tempUser.office.mainCharge] = newValue;        
      }
      if(name === "designationSuffix"){
        tempUser.designationSuffix[tempUser.office.mainCharge] = newValue;        
      }

      setUsers(tempUser)
      setValue(tempValue)                      
    }  

    let id = offices?.find(x => x.name ===  users.office.mainCharge)?._id
    let officeBody = {"id":id};

    //Check this filter
    const sameOfficeUsers = Object.values(userData)?.filter(x => (x.office.mainCharge ===  users.office.mainCharge) || (x.office.additionalCharge.includes( users.office.mainCharge)))
    const sameOfficeDesgnUsers = sameOfficeUsers?.filter(x => Object.values(x.designation).includes(users.designation[users.office.mainCharge]))

    //Sort users having same office and designation in order of numIndex using Quick Sort Algorithm.

    const sortedSameOfficeDesgnUsers = sameOfficeDesgnUsers.sort((a,b) => (a.numSuffix[users.office.mainCharge] > b.numSuffix[users.office.mainCharge]) ? 1 : ((b.numSuffix[users.office.mainCharge] > a.numSuffix[users.office.mainCharge]) ? -1 : 0))
    // console.log(sortedSameOfficeDesgnUsers)
    

    const onClickConfirm = () => {
        let tempUsers = structuredClone(users);
        if(Object.values(userData).map(x => x.mobileNo).includes(tempUsers.mobileNo)){
          return alert("Mobile Number Already Exists. Please use different mobile number")
        }
        if(Object.values(userData).map(x => x.email).includes(tempUsers.email)){
          return alert("Email ID Already Exists. Please use different Email")
        }
        if(Object.values(userData).map(x => x.employeeID).includes(tempUsers.employeeID)){
          return alert("Employee ID Already Exists. Please use unique Employee ID")
        }
        setSubdispl("block");
        if(!sortedSameOfficeDesgnUsers?.length){
          tempUsers.numSuffix[ users.office.mainCharge] = 1;
        }
        for(let i = 1; i < (sortedSameOfficeDesgnUsers?.length + 1); i++){
          if(sortedSameOfficeDesgnUsers[i-1]?.numSuffix[ users?.office?.mainCharge] !== (sortedSameOfficeDesgnUsers[i]?.numSuffix[ users?.office?.mainCharge]-1)){
            tempUsers.numSuffix[ users.office.mainCharge] = i+1;
            break;
          }           
        }
        tempUsers.roles = {...tempUsers.roles, [ users.office.mainCharge]:[]};        
        if(( users.office.mainCharge === offices?.find(x => x.level === "level1").name) && (officeType.find(x=> x.type=== presentOffType)?.UnitHead?.includes(users?.designation[users.office.mainCharge]))){
          console.log("first")
          tempUsers.roles[ users.office.mainCharge].push("UnitHead");
          setReportingOfficer("Not Applicable");
        }else{
          if(officeType?.find(x=> x.type=== presentOffType)?.unitHead?.includes(users.designation[users.office.mainCharge])){
            console.log("second")
            tempUsers.roles[ users.office.mainCharge].push("UnitHead")
            let supOffice = offices?.find(x => x.name ===  users.office.mainCharge).superioroffice;
            let repoOfficer = offices?.find(a => a.name === supOffice).unitHead;
            if(repoOfficer?.length) {
              console.log("third")
              setReportingOfficer(repoOfficer);
            }else{setSubdispl("none"); alert("Reporting Officer not Registered"); console.log("fourth")}
          } else {
            console.log("fifth")
            console.log(offices?.find(x => x.name ===  users.office.mainCharge))
            if(offices?.find(x => x.name ===  users.office.mainCharge)?.unitHead?.length){
            console.log("sixth")
            setReportingOfficer(offices.find(x => x.name ===  users.office.mainCharge).unitHead)
            }else{setSubdispl("none"); alert("Reporting Officer not Registered"); console.log("Seventh")}
          }
      }    

      if(( users.office.mainCharge === offices?.find(x => x.level === "level1").name) && (officeType.find(x=> x.type=== presentOffType).unitHead.includes(users.designation[users.office.mainCharge]))){
        alert("You are creating Top level user. Reporting officer is Not Applicable."); 

      }else{
        alert("Please check your reporting officer before final submission");
      }       
      setUsers(tempUsers);
    }
    
    const onClickFormSubmit = async (e) =>{
        e.preventDefault();
        // if button enabled with JS hack
        const v1 = EMAIL_REGEX.test(users.email)
        const v2 = PWD_REGEX.test(users.password);
        if (!v1 || !v2) {
              setErrMsg("Invalid Entry");
              return;
        }
        try{     
        const body ={...users}
        //Check if the present office type includes the present designation for unit head. 
        if(officeType.find(x=> x.type=== presentOffType).unitHead.includes(users.designation[users.office.mainCharge])){
          if(offices?.find(x => x.name ===  users.office.mainCharge)?.unitHead?.length){
            alert("Unit Head already posted");
            return
          }
          const res = await addNewUser(body);
          officeBody = {...officeBody, "unitHead":res.data.createdId};
          const resOffice = await updateOff(officeBody);
          console.log(resOffice)
        }else {
          const res = await addNewUser(body);
        }
        alert(`New User Created Successfully. Name: ${users.name.firstName} ${users.name.middleName} ${users.name.lastName}, Email:${users.email}, Office:${users.office.mainCharge}, Designation:${users.designation[users.office.mainCharge]}`)
        
        let tempUser = structuredClone(initialUserState);
        let tempValue = structuredClone(initialValueState);
        tempValue.level0 = offices[0].name
        tempUser.office.mainCharge = Object.values(offices).find( x => x.level === "level1").name
        setUsers(tempUser);
        setValue(tempValue);
        setSubdispl('none')
        setPresentOffType(Object.values(offices).find( x => x.level === "level1")?.type)
        } catch(err){
            if (!err?.response) {
                setErrMsg('No Server Response');
            } else if (err.response?.status === 409) {
                setErrMsg('Username Taken');
            } else {
                setErrMsg('Registration Failed')
            }
            // errRef.current.focus();
        }
    }
    console.log(reportingOfficer)


    // console.log(validFirstName,validMiddleName, validLastName, validEmail, validPwd, validMatch, validMobile,validEmpId, validLandline, validOfficeAdd)

    // console.log(firstNameFocus, middleNameFocus, lastNameFocus, emailFocus, empIDFocus, pwdFocus, matchFocus, mobileFocus, officeAddFocus)


  const {officedata} = useGetofficesQuery("officeList", {
    selectFromResult: ({ data }) => ({
      officedata: data?.entities
    }),
  })

  const {officetype} = useGetofficetypeQuery("officeTypeList", {
    selectFromResult: ({ data }) => ({
      officetype: data?.entities
    }),
  })

  const {designationsuffix}= useGetdesignationsuffixQuery("desigsuffix", {
    selectFromResult: ({ data }) => ({
      designationsuffix: data?.entities
    }),
  })
  const {storeoffices}= useGetStoreOfficesQuery("storeoffices", {
    selectFromResult: ({ data }) => ({
      storeoffices: data?.entities
    }),
  })

  const {designation} = useGetdesignationsQuery("designations", {
    selectFromResult: ({ data }) => ({
        designation: data?.entities
      }),
  })

  const {userdata} = useGetUsersQuery("usersList", {
    selectFromResult: ({ data }) => ({
      userdata: data?.entities
    }),
  })
console.log(officedata, count)

  useEffect(()=>{
    if(officedata){
        const finalOfficeData = Object.values(officedata)
        setOffices(finalOfficeData)
        if(!users?.office?.mainCharge?.length){
          let renderArray = [];
          renderArray.push(finalOfficeData?.find( x => x.level === "level1")?.name)
          setRenderFields(renderArray)
        let tempUser = structuredClone(users)
        tempUser.office.mainCharge = finalOfficeData.find( x => x.level === "level1")?.name
        setPresentOffType(finalOfficeData.find( x => x.level === "level1")?.type)
        let tempVal={...value}
        tempVal.level0 = finalOfficeData.find( x => x.level === "level1")?.name;
        setValue(tempVal);
        setUsers(tempUser)
      }
    }
  },[officedata])


  useEffect(()=>{
    if(officetype){
        setOfficeType(Object.values(officetype))
    }
  },[officetype])


  useEffect(()=>{
    if(designationsuffix){
        setDesigSuffix(Object.values(designationsuffix))
    }
  },[designationsuffix])

  useEffect(()=>{
    if(storeoffices){
        setStoreOffices(Object.values(storeoffices))
    }
  },[storeoffices])

  useEffect(()=>{
    if(designation){
        setDesig(Object.values(designation))
    }
  },[designation])

  useEffect(()=>{
    if(userdata){
      setUserData(userdata)
    }
  },[userdata])

  
// console.log(storeOffices.map(x=> x.name))
    return (
        <>
        <HeadingWrap>
          <Span>Add New User</Span>
        </HeadingWrap>

        <form onSubmit={(e)=>onClickFormSubmit(e)}>
        
        <Adduserformcont>
          <LabelInputWrapper>
            <TextField
              id="outlined-basic"
              size='small'
              ref={userRef}
              name='firstName'
              onChange={(event, newValue) => onChangeuserform(event, newValue)}
              label="First Name"
              value={users.name.firstName}
              variant="outlined"
              onFocus={() => setFirstNameFocus(true)}
              onBlur={() => setFirstNameFocus(false)}
              sx={{backgroundColor:"white"}}
            />      
            { firstNameFocus && !validFirstName ? <div>Please Enter Valid First Name</div>:null}
          </LabelInputWrapper>

          <LabelInputWrapper>
                <TextField
                  id="outlined-basic"
                  size='small'
                  ref={userRef}
                  name='middleName'
                  onChange={(event, newValue) => onChangeuserform(event, newValue)}
                  label="Middle Name"
                  value={users.name.middleName}
                  variant="outlined"
                  onFocus={() => setMiddleNameFocus(true)}
                  onBlur={() => setMiddleNameFocus(false)}
                  sx={{backgroundColor:"white"}}
                  />    
                {middleNameFocus && !validMiddleName ? <div>Please Enter Valid Middle Name</div>:null}
            </LabelInputWrapper>

            <LabelInputWrapper>
                <TextField
                  id="outlined-basic"
                  size='small'
                  ref={userRef}
                  name='lastName'
                  onChange={(event, newValue) => onChangeuserform(event, newValue)}
                  label="Last Name"
                  value={users.name.lastName}
                  variant="outlined"
                  onFocus={() => setLastNameFocus(true)}
                  onBlur={() => setLastNameFocus(false)}
                  sx={{backgroundColor:"white"}}
                  />
                {lastNameFocus && !validLastName ? <div>Please Enter Valid Last Name</div>:null}
            </LabelInputWrapper>

            <LabelInputWrapper>
                <TextField
                  id="outlined-basic"
                  size='small'
                  ref={userRef}
                  name='email'
                  onChange={(event, newValue) => onChangeuserform(event, newValue)}
                  label="Email"
                  value={users.email}
                  variant="outlined"
                  onFocus={() => setEmailFocus(true)}
                  onBlur={() => setEmailFocus(false)}
                  sx={{backgroundColor:"white"}}
                  />
                {emailFocus && !validEmail ? <span>Email Error Message</span>: null}
            </LabelInputWrapper>             

            <LabelInputWrapper>
                <TextField
                  id="outlined-basic"
                  size='small'
                  ref={userRef}
                  name='password'
                  type='password'
                  onChange={(event, newValue) => onChangeuserform(event, newValue)}
                  label="Password"
                  value={users.password}
                  variant="outlined"
                  onFocus={() => setPwdFocus(true)}
                  onBlur={() => setPwdFocus(false)}
                  sx={{backgroundColor:"white"}}
                  />               
                {pwdFocus && !validPwd ?<div>Password Error Message</div>:null}
            </LabelInputWrapper>

            <LabelInputWrapper>
                <TextField
                  id="outlined-basic"
                  size='small'
                  ref={userRef}
                  name='confirmpassword'
                  type='password'
                  onChange={(event, newValue) => onChangeuserform(event, newValue)}
                  label="Confirm Password"
                  value={value.confirmpassword}
                  variant="outlined"
                  onFocus={() => setMatchFocus(true)}
                  onBlur={() => setMatchFocus(false)}
                  sx={{backgroundColor:"white"}}
                  />
                {matchFocus && !validMatch? <div>Password Error Message</div>:null}
            </LabelInputWrapper>

            <LabelInputWrapper>
                <TextField
                  id="outlined-basic"
                  size='small'
                  ref={userRef}
                  name='mobileNo'
                  type='text'
                  onChange={(event, newValue) => onChangeuserform(event, newValue)}
                  label="Enter Mobile Number"
                  value={users.mobileNo}
                  variant="outlined"
                  onFocus={() => setMobileFocus(true)}
                  onBlur={() => setMobileFocus(false)}
                  sx={{backgroundColor:"white"}}
                  />             
                {mobileFocus && !validMobile ? <div>Enter Valid Mobile Number</div>: null}
            </LabelInputWrapper>

            <LabelInputWrapper>
                <TextField
                  id="outlined-basic"
                  size='small'
                  ref={userRef}
                  name='employeeID'
                  type='text'
                  onChange={(event, newValue) => onChangeuserform(event, newValue)}
                  label="Enter Employee ID"
                  value={users.employeeID}
                  variant="outlined"
                  onFocus={() => setEmpIdFocus(true)}
                  onBlur={() => setEmpIdFocus(false)}
                  sx={{backgroundColor:"white"}}
                  /> 
                {empIDFocus && !validEmpId ? <div>Enter Valid Employee ID</div>: null}
            </LabelInputWrapper>

            <LabelInputWrapper>
                <TextField
                  id="outlined-basic"
                  size='small'
                  ref={userRef}
                  name='officeLandLine'
                  type='text'
                  onChange={(event, newValue) => onChangeuserform(event, newValue)}
                  label="Enter Office Landline"
                  value={users.officeLandLine}
                  variant="outlined"
                  onFocus={() => setLandlineFocus(true)}
                  onBlur={() => setLandlineFocus(false)}
                  sx={{backgroundColor:"white"}}
                  />
                {landlineFocus && !validLandline ? <div>Enter Valid Landline Number</div>:null}
            </LabelInputWrapper>

            <LabelInputWrapper>
                <TextField
                  id="outlined-basic"
                  size='small'
                  ref={userRef}
                  name='officeAddress'
                  type='text'
                  onChange={(event, newValue) => onChangeuserform(event, newValue)}
                  label="Enter Office Address"
                  value={users.officeAddress}
                  variant="outlined"
                  onFocus={() => setOfficeAddFocus(true)}
                  onBlur={() => setOfficeAddFocus(false)}
                  sx={{backgroundColor:"white"}}
                  />                
                {officeAddFocus && !validOfficeAdd ? <div>Enter Valid Office Address</div>: null}
            </LabelInputWrapper>
            {console.log(renderFields)}      

            {renderFields.concat([""]).map((item,index)=>{
                return (
            <LabelInputWrapper key={index} disp={displ.level1}>
               <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  size='small'
                  value={value[`level${index}`]}
                  onChange={(event, newValue) => onChangeuserform(event, newValue, `level${index}`)}
                  options={offices.filter((i,k)=>i.superioroffice === value[`level${index-1}`])
                  ?.map((item,index) => item.name)}
                  sx={{ width: "50%", backgroundColor:"white" }}
                  //In label the field is fetched dynamically. If no field is selected it gives all office types separated by "/". As soon as we select the office the corresponding office typw shows in the label.
                  renderInput={(params) => <TextField {...params} label={offices.filter((i,k)=>i.superioroffice === value[`level${index-1}`])?.map((item,index) => item.name).length? fetchLabel(index, value, officedata):"No Options"} />}
                  // Object.values(userData).find(x=> x.name ) value[`level${index}`]
                />
              </LabelInputWrapper>
                )
            })}
            <LabelInputWrapper>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  size='small'
                  value={users?.designation[users?.office?.mainCharge]?.length? users?.designation[users?.office?.mainCharge]:"" }
                  onChange={(event, newValue) => onChangeuserform(event, newValue, "designation")}
                  options={desig?.map((item)=>item.name)}
                  sx={{ width: "50%", backgroundColor:"white" }}
                  renderInput={(params) => <TextField {...params} label={"Enter Designation"} />}
                /> 
            </LabelInputWrapper>

            <LabelInputWrapper>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  size='small'
                  value={users?.designationSuffix[users?.office?.mainCharge]?.length? users?.designationSuffix[users?.office?.mainCharge]:"" }
                  onChange={(event, newValue) => onChangeuserform(event, newValue, "designationSuffix")}
                  options={desigSuffix?.map((item)=>item.name)}
                  sx={{ width: "50%", backgroundColor:"white" }}
                  renderInput={(params) => <TextField {...params} label={"Enter Designation Suffix"} />}
                /> 
            </LabelInputWrapper>       
        </Adduserformcont>
        <SubmitButton type='button' disabled={!validFirstName  || !validEmpId || !validLandline || !validPwd || !validMatch || !validMobile || !validOfficeAdd || !users?.designation[users?.office?.mainCharge]?.length ? true: false} onClick={(e)=>onClickConfirm(e)}>Confirm</SubmitButton>
        
        <div style={{display:subdispl, marginTop:"20px", marginBottom:"20px"}}>
          <SubHeadingField>
            Reporting Officer:
          </SubHeadingField>
          <TextField
            id="outlined-basic"
            size='small'
            name='reportingofficer'
            type='text'
            value = {reportingOfficer === "Not Applicable"? reportingOfficer:`${userData[reportingOfficer]?.name?.firstName} ${userData[reportingOfficer]?.name?.middleName} ${userData[reportingOfficer]?.name?.lastName} (${userData[reportingOfficer]?.designation[userData[reportingOfficer]?.office?.mainCharge]})`}
            variant="outlined"
            sx={{backgroundColor:"lightblue", width:"25%"}}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AccountCircle />
                </InputAdornment>
              ),
            }}
            readOnly
            /> 

        </div>
        <SubmitButton type='submit' style={{display:subdispl}}>Submit</SubmitButton>            
        </form>      
        </>
      )
}
export default AddUsers;